import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { Drawer, Collapse, Form, Input } from "antd";
import { FaSearch } from "react-icons/fa";
import React, { useState } from "react";
import { KEYS } from "../../../Config/Keys";
import { fallbackprofile } from "../../../common/Utils";
import FadeInImage from "../../../common/Images/FadeInImage";
import { Info } from "../../../common/Alerts/Message";
import useVariables from "../../../common/hooks/useVariables";
import {
  ALL_CAMPAIGNS,
  CREATE_CAMPAIGN,
  DRAFTED_CAMPAIGNS
} from "../../../Config/helpers/sponsorRoutes";

const SponsorDrawer = ({ onClose, visible }) => {
  const navigate = useNavigate();
  const { query, id } = useParams();
  const { pathname } = useLocation();
  const [text, settext] = useState(query);

  const { Panel } = Collapse;
  const { viewer } = useVariables();

  var currentflag = "sponsor",
    currentid = viewer?.id;

  const notClickable = pathname === "/sponsor";
  const ALERT = () => Info("Create Profile First");

  return (
    <Drawer
      bodyStyle={{ marginLeft: "5px" }}
      title="Spoflex"
      placement="right"
      onClose={onClose}
      visible={visible}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <FadeInImage
          type="Fadenavprofile"
          fallaback={fallbackprofile}
          src={KEYS.API + "/" + viewer?.profile}
        />
        <span
          style={{
            paddingLeft: "20px",
            userSelect: "none",
            fontSize: "15",
            fontWeight: 600
          }}>
          {viewer?.name}
        </span>
      </div>
      <Form
        style={{ margin: "20px 0 0 0" }}
        onFinish={() => {
          if (text?.trim().length > 0 && !notClickable) {
            onClose();
            navigate(`/sponsor/search/${text}`, { state: text });
          } else if (notClickable) ALERT();
        }}>
        <Form.Item style={{ margin: "0px", width: "100%" }} name="search">
          <Input
            size="middle"
            value={text}
            defaultValue={query}
            onChange={(e) => settext(e.currentTarget.value)}
            placeholder="Search"
            style={{ borderRadius: "20px", padding: "8px 5px" }}
            prefix={
              <FaSearch
                onClick={() => {
                  if (text?.trim().length > 0) {
                    onClose();
                    navigate(`/sponsor/search/${text}`, { state: text });
                  }
                }}
                style={{
                  cursor: "pointer",
                  color: "#8F8F8F",
                  marginRight: "10px",
                  width: "25px",
                  height: "16px"
                }}
              />
            }
          />
        </Form.Item>
      </Form>

      <div className="drawerpadding" onClick={onClose}>
        {notClickable ? <div onClick={ALERT}>Home</div> : <Link to="/sponsor/timeline">Home</Link>}
      </div>
      <div className="drawerpadding" onClick={onClose}>
        {notClickable ? (
          <div onClick={ALERT}>Profile</div>
        ) : (
          <Link to="/sponsor/timeline">Profile</Link>
        )}
      </div>
      {id !== undefined ? (
        <div style={{ paddingTop: "5px" }}>
          {notClickable ? (
            <div className="Nav_a" style={{ marginTop: "-6px" }} onClick={ALERT}>
              Campaign
            </div>
          ) : (
            <Collapse className="customz" style={{ padding: "0px" }} ghost>
              <Panel className="custom" header="Campaign" key="1">
                <div>
                  <Link onClick={onClose} className="drawerpadding" to={ALL_CAMPAIGNS}>
                    Campaigns
                  </Link>
                </div>
                <div className="drawerpadding" onClick={onClose}>
                  <Link className="drawerpadding" to={DRAFTED_CAMPAIGNS}>
                    Draft Campaigns
                  </Link>{" "}
                </div>

                <div className="drawerpadding" onClick={onClose}>
                  <Link className="drawerpadding" to={CREATE_CAMPAIGN}>
                    Create Events
                  </Link>{" "}
                </div>
              </Panel>
            </Collapse>
          )}
        </div>
      ) : null}

      <div style={{ paddingTop: "5px" }}>
        {notClickable ? (
          <div className="Nav_a" style={{ marginTop: "-6px" }} onClick={ALERT}>
            Contracts
          </div>
        ) : (
          <Collapse className="customz" style={{ padding: "0px" }} ghost>
            <Panel className="custom" header="Contracts" key="1">
              <div onClick={onClose}>
                <Link className="drawerpadding" state={"panels"} to="/sponsor/search/panels">
                  Join Panel
                </Link>
              </div>
              <div className="drawerpadding" onClick={onClose}>
                <Link className="drawerpadding" to="/sponsor/panels">
                  My Panels
                </Link>
              </div>
              <div className="drawerpadding" onClick={onClose}>
                <Link className="drawerpadding" to="/sponsor/createpanel">
                  Create Panel
                </Link>{" "}
              </div>
            </Panel>
          </Collapse>
        )}
      </div>

      <div className="drawerpadding" onClick={onClose}>
        {notClickable ? (
          <div onClick={ALERT}>Settings and Privacy</div>
        ) : (
          <Link
            state={{ currentflag, currentid }}
            to={currentflag === "panel" ? `/sponsor/panel/${id}/settings` : "/sponsor/settings"}>
            Settings and Privacy
          </Link>
        )}
      </div>
      <div className="drawerpadding">
        <Link
          to="/signin"
          onClick={() => {
            localStorage.removeItem("ProfileID");
            localStorage.removeItem("userToken");
            localStorage.removeItem("userDetails");
            localStorage.removeItem("panel");
            localStorage.removeItem("viewer");
            localStorage.removeItem("CoverPic");
            localStorage.removeItem("ProfilerPic");
          }}>
          Log out
        </Link>
      </div>
    </Drawer>
  );
};

export default SponsorDrawer;
